import { Component, ViewEncapsulation } from '@angular/core'

@Component({
  selector: 'kdgh-centered-page',
  templateUrl: './centered-page.component.html',
  styleUrls: ['./centered-page.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CenteredPageComponent {}
